import { Component, computed, inject } from '@angular/core';
import { LinkComponent } from '@shared/components/link/link.component';
import { MediaComponent } from '@shared/components/media/media.component';
import { Link, MediaContainer } from '@core/models/atomics.model';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-banner-grid',
  templateUrl: './cx-banner-grid.component.html',
  styleUrl: './cx-banner-grid.component.scss',
  imports: [MediaComponent, LinkComponent],
})
export class CxBannerGridComponent {
  protected readonly data = inject<{
    banners: {
      uid: string;
      medias: MediaContainer;
      link: Link;
      columnSize: number;
    }[];
  }>(CX_ABSTRACT_COMPONENT_DATA);

  banners = computed(() => this.data.banners);
}
